// extracted by mini-css-extract-plugin
export default {"tabItem":"HomeScreenContent_tabItem__0aohV"};